import * as semver from 'semver'

import { isProduction } from '@/utils/dev'

const MINIMUM_APP_VERSION = '0.0.0'

const AOSMilestoneAppVersion = Object.freeze({
  B_MART_OPEN: '8.42.0',
  CHATBOT_OPEN: '10.12.0'
})

const IOSMilestoneAppVersion = Object.freeze({
  B_MART_OPEN: '6.42.0',
  CHATBOT_OPEN: '10.12.0'
})

// false: 미사용, true: 조건부 사용
const PROVIDE_FEATURE_MAP = Object.freeze({
  DELIVERY_RESERVATION: true,
  IMMEDIATE_DISCOUNT: false,
  COUPON_DISCOUNT: true,
  BAEMIN_POINT: true,
  DELIVERY_TIP_DISCOUNT: true
})

const isProvideDeliveryReservation = ({
  appVersion = MINIMUM_APP_VERSION,
  isAndroid,
  includeReturnOrExchangeProduct = false
}) => {
  const milestoneAppVersion = isAndroid ? AOSMilestoneAppVersion : IOSMilestoneAppVersion

  return (
    PROVIDE_FEATURE_MAP.DELIVERY_RESERVATION &&
    semver.gte(appVersion, milestoneAppVersion.B_MART_OPEN) &&
    !includeReturnOrExchangeProduct
  )
}

const isProvideImmediateDiscount = ({ appVersion = MINIMUM_APP_VERSION, isAndroid }) => {
  const milestoneAppVersion = isAndroid ? AOSMilestoneAppVersion : IOSMilestoneAppVersion

  return (
    PROVIDE_FEATURE_MAP.IMMEDIATE_DISCOUNT &&
    semver.gte(appVersion, milestoneAppVersion.B_MART_OPEN)
  )
}

const isProvideCouponDiscount = ({
  appVersion = MINIMUM_APP_VERSION,
  isAndroid,
  isSign = false,
  includeReturnOrExchangeProduct = false
}) => {
  const milestoneAppVersion = isAndroid ? AOSMilestoneAppVersion : IOSMilestoneAppVersion

  return (
    PROVIDE_FEATURE_MAP.COUPON_DISCOUNT &&
    semver.gte(appVersion, milestoneAppVersion.B_MART_OPEN) &&
    isSign &&
    !includeReturnOrExchangeProduct
  )
}

const isProvideBaeminPoint = ({ isSign = false, includeReturnOrExchangeProduct = false }) => {
  return PROVIDE_FEATURE_MAP.BAEMIN_POINT && isSign && !includeReturnOrExchangeProduct
}

const isProvideGiftCard = ({ isSign = false, includeReturnOrExchangeProduct = false }) => {
  return isSign && !includeReturnOrExchangeProduct
}

const isProvideDeliveryTipDiscount = PROVIDE_FEATURE_MAP.DELIVERY_TIP_DISCOUNT

const isProvideChatbotOpen = ({ appVersion = MINIMUM_APP_VERSION, isAndroid }) => {
  const milestoneAppVersion = isAndroid ? AOSMilestoneAppVersion : IOSMilestoneAppVersion

  return semver.gte(appVersion, milestoneAppVersion.CHATBOT_OPEN)
}

export {
  isProvideDeliveryReservation,
  isProvideImmediateDiscount,
  isProvideCouponDiscount,
  isProvideBaeminPoint,
  isProvideDeliveryTipDiscount,
  isProvideGiftCard,
  isProvideChatbotOpen
}

export default {}
